import { HalLink } from './hal-link.mode';

export interface HalSearchResults<T> {
  page: HalPage;
  _embedded: HalSearchEntries<T>;
  _links: HalSearchLinks;
}

export interface HalPage {
  number: number;
  totalElements: number;
  size: number;
  totalPages: number;
}

export interface HalSearchLinks {
  next: HalLink;
  last: HalLink;
  prev: HalLink;
  self: HalLink;
  first: HalLink;
}

export interface HalSearchEntries<T> {
  entries: Array<T>;
}
